import TimeInfo from '@/taskpane/events/models/time-info'

export default function getTimeInfo(start: Date, end: Date): TimeInfo {
  return {
    calendarTimezoneOffset: start.getTimezoneOffset(), //int
    fromDate: start.toISOString(), //DateTime
    fromDateFull: start, //DateTime
    fromTime: start.toISOString(), //DateTime
    untilDate: end.toISOString(), //DateTime
    untilDateFull: end, //DateTime
    untilTime: end.toISOString(), //DateTime
  }
}
